(() => {
  if (window.__rasterkarten) return;
  window.__rasterkarten = true;
  const editor = !!(window.Shopify && window.Shopify.designMode);

  function setzen() {
    const raster = document.querySelector('.product-grid');
    if (!raster) return;
    raster.querySelectorAll('.akl-karte-platz').forEach((li) => li.remove());
    const sichtbar = [...raster.querySelectorAll('.product-grid__item[data-product-id]')].filter(
      (li) => li.style.display !== 'none' && (li.dataset.page || '1') === '1'
    );
    [...document.querySelectorAll('template[data-akl-karte]')]
      .sort((a, b) => Number(b.dataset.aklKarte) - Number(a.dataset.aklKarte))
      .forEach((t) => {
        if (!editor && t.content.querySelector('[aria-disabled="true"]')) return;
        if (!sichtbar.length) return;
        const nach = Math.min(Number(t.dataset.aklKarte) || 6, sichtbar.length);
        const li = document.createElement('li');
        li.className = 'product-grid__item akl-karte-platz' + (t.dataset.aklBreit === 'true' ? ' akl-karte-platz--breit' : '');
        li.appendChild(t.content.cloneNode(true));
        sichtbar[nach - 1].after(li);
      });
    ausrichten(raster);
  }

  function spalten(raster) {
    return getComputedStyle(raster).gridTemplateColumns.split(' ').filter(Boolean).length;
  }
  function ausrichten(raster) {
    const n = spalten(raster);
    if (n < 3) return;
    raster.querySelectorAll('.akl-karte-platz--breit').forEach((karte) => {
      for (let schritt = 0; schritt < n; schritt++) {
        let zellen = 0;
        for (let x = raster.firstElementChild; x && x !== karte; x = x.nextElementSibling) {
          if (getComputedStyle(x).display === 'none') continue;
          zellen += x.classList.contains('akl-karte-platz--breit') ? 2 : 1;
        }
        if (zellen % n !== n - 1) return;
        let weiter = karte.nextElementSibling;
        while (weiter && (getComputedStyle(weiter).display === 'none' || weiter.classList.contains('akl-karte-platz'))) weiter = weiter.nextElementSibling;
        if (!weiter) return;
        weiter.after(karte);
      }
    });
  }
  let letzteSpalten = 0;
  window.addEventListener('resize', () => {
    const raster = document.querySelector('.product-grid');
    if (!raster) return;
    const n = spalten(raster);
    if (n !== letzteSpalten) { letzteSpalten = n; spaeter(); }
  });

  let wartet = false;
  const spaeter = () => {
    if (wartet) return;
    wartet = true;
    setTimeout(() => { wartet = false; beobachter.disconnect(); setzen(); beobachten(); }, 50);
  };
  const beobachter = new MutationObserver(spaeter);
  const beobachten = () => beobachter.observe(document.querySelector('main') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  document.addEventListener('input', (e) => { if (e.target instanceof Element && e.target.matches('[data-one-zoll]')) spaeter(); });
  beobachten();
  setzen();
})();
